import { $authHost } from "../index";

export const getPaymentStatusByID = async (id: number | string) => {
    const { data } = await $authHost.get(`/api/subscription/status/${id}`)
    return data;
}